"use client";
import { useSelector, useDispatch } from "react-redux";

import { setFreeText } from "@/src/store/filter";

import Input from "@/src/components/common/input";

import styles from "../styles.module.css";

const FreeTextInput = () => {
  const ReduxFreetext = useSelector((state) => state.filter.freetext);

  const dispatch = useDispatch();

  const handleFreetextInputChange = (e) => {
    const { value } = e.target;

    if (value) {
      dispatch(setFreeText({ key: "free_text", value }));
    } else {
      dispatch(setFreeText(null));
    }
  };

  return (
    <div className={styles.searchInput}>
      <Input
        placeholder="Arama Kelimesi"
        value={ReduxFreetext?.value ?? ""}
        onChange={(e) => handleFreetextInputChange(e)}
        inputClass={styles.minMaxInput}
      />
    </div>
  );
};

export default FreeTextInput;
